import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { api } from "@/lib/api";
import {
  LayoutDashboard, Package, Bot, FileText, ReceiptText, Bell, LogOut, History, Users, Contact, MessagesSquare, Settings2, Crown, Activity, SlidersHorizontal, ShoppingCart, Truck, KeyRound } from "lucide-react";

const NAV = [
  { to: "/dashboard", label: "Dashboard", icon: LayoutDashboard, testid: "nav-dashboard" },
  { to: "/agents", label: "Tim AI Agent", icon: MessagesSquare, testid: "nav-agents" },
  { to: "/approvals", label: "Approval Direktur", icon: Crown, testid: "nav-approvals", adminOnly: true },
  { to: "/manager", label: "Manager", icon: Activity, testid: "nav-manager" },
  { to: "/agent-settings", label: "Pengaturan Agent", icon: SlidersHorizontal, testid: "nav-agent-settings", adminOnly: true },
  { to: "/ai", label: "AI Assistant", icon: Bot, testid: "nav-ai" },
  { to: "/quotations", label: "Penawaran", icon: FileText, testid: "nav-quotations" },
  { to: "/invoices", label: "Invoice", icon: ReceiptText, testid: "nav-invoices", adminOnly: true },
  { to: "/purchase-orders", label: "PO Pembelian", icon: ShoppingCart, testid: "nav-purchase-orders", adminOnly: true },
  { to: "/catalog", label: "Katalog Produk", icon: Package, testid: "nav-catalog" },
  { to: "/account", label: "Ganti Password", icon: KeyRound, testid: "nav-account" },
  { to: "/customers", label: "Customer", icon: Contact, testid: "nav-customers" },
  { to: "/suppliers", label: "Supplier", icon: Truck, testid: "nav-suppliers" },
  { to: "/price-history", label: "Riwayat Harga", icon: History, testid: "nav-price-history", adminOnly: true },
  { to: "/users", label: "Tim & Akses", icon: Users, testid: "nav-users", adminOnly: true },
  { to: "/settings", label: "Company Profile", icon: Settings2, testid: "nav-settings", adminOnly: true },
  { to: "/notifications", label: "Notifikasi", icon: Bell, testid: "nav-notifications" },
];

export default function Layout({ children }) {
  const { user, logout } = useAuth();
  const loc = useLocation();
  const [unread, setUnread] = useState(0);

  useEffect(() => {
    api.get("/notifications").then((r) => setUnread(r.data.filter((n) => !n.read).length)).catch(() => {});
  }, [loc.pathname]);

  return (
    <div className="min-h-screen flex bg-background">
      <aside className="w-64 shrink-0 border-r border-border flex flex-col fixed h-screen bg-card z-20">
        <div className="px-6 py-6 border-b border-border">
          <div className="bg-white rounded-sm px-3 py-2.5 inline-flex">
            <img src="/grcom-logo.png" alt="CV GRcom" className="h-8 w-auto" />
          </div>
          <div className="overline text-muted-foreground mt-2">AI Admin Panel</div>
        </div>
        <nav className="flex-1 min-h-0 overflow-y-auto py-4 px-3 space-y-1" data-testid="sidebar-nav">
          {NAV.map((n) => {
            if (n.adminOnly && user?.role !== "admin") return null;
            const active = loc.pathname === n.to || (n.to !== "/" && loc.pathname.startsWith(n.to));
            const Icon = n.icon;
            return (
              <Link
                key={n.to}
                to={n.to}
                data-testid={n.testid}
                className={`flex items-center gap-3 px-3 py-2.5 rounded-sm text-sm transition-colors duration-150 ${
                  active
                    ? "bg-primary text-primary-foreground font-medium"
                    : "text-muted-foreground hover:bg-secondary hover:text-foreground"
                }`}
              >
                <Icon className="w-4 h-4" />
                <span className="flex-1">{n.label}</span>
                {n.to === "/notifications" && unread > 0 && (
                  <span className="bg-accent text-accent-foreground text-xs font-bold px-1.5 rounded-sm">{unread}</span>
                )}
              </Link>
            );
          })}
        </nav>
        <div className="border-t border-border p-4">
          <div className="mb-3">
            <div className="text-sm font-medium truncate">{user?.name}</div>
            <div className="overline text-muted-foreground truncate">{user?.email}</div>
          </div>
          <button
            data-testid="logout-button"
            onClick={logout}
            className="flex items-center gap-2 text-sm text-muted-foreground hover:text-destructive transition-colors duration-150"
          >
            <LogOut className="w-4 h-4" /> Keluar
          </button>
        </div>
      </aside>
      <main className="flex-1 ml-64 min-h-screen">{children}</main>
    </div>
  );
}
